import { useState } from 'react'
import type { ReactNode } from 'react'
import { copyRows, downloadCSV, type ExportColumn } from '@/ui/export'

/** Copy / CSV of the rows a table is showing, above it — the Ledger's export bar. */
export function ExportBar<T>({
  filename,
  rows,
  columns,
  lead,
}: {
  filename: string
  rows: readonly T[]
  columns: readonly ExportColumn<T>[]
  /** Before Export — the table's Enlarge button (PopOut). */
  lead?: ReactNode
}) {
  const [note, setNote] = useState<string | null>(null)
  return (
    <div className="xbar">
      {lead}
      <span style={lead ? { marginLeft: 8 } : undefined}>Export</span>
      <button
        type="button"
        onClick={async () => {
          const r = await copyRows(rows, columns)
          setNote(r === 'ok' ? 'Copied' : 'This view cannot use the clipboard.')
        }}
      >
        Copy
      </button>
      <button
        type="button"
        onClick={() => {
          const r = downloadCSV(filename, rows, columns)
          setNote(r === 'ok' ? null : 'This view cannot start a download. Use Copy.')
        }}
      >
        CSV
      </button>
      {note && <em>{note}</em>}
    </div>
  )
}
